import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getServices } from "../../apiServices/apiServices";
import LoadingGif from "../../assets/loading_anim.gif";
import EmptyingReportTable from "../../components/common/EmptyingReportTable";
import { jwtDecode } from "jwt-decode";

function EmptyingReport({ branch_id }) {
  const [loading, setLoading] = useState(false);
  const [postrunList, setPostrunList] = useState([]);
  const navigate = useNavigate();
  const { subbranch_id } = useParams();
  const access_token =
    localStorage.getItem("gassol-super-admin-token") ||
    localStorage.getItem("gassol-admin-token") ||
    localStorage.getItem("gassol-head-branch-token") ||
    localStorage.getItem("gassol-sub-branch-token");
  const decode = jwtDecode(access_token);

  useEffect(() => {
    if (!access_token) {
      navigate("/sign_in");
    }

    window.scrollTo(0, 0);

   // Only fetch if token and branch id exist
    if (branch_id || subbranch_id) {
      fetchPostrunList();
    }
  }, []);

  const fetchPostrunList = async () => {
    setLoading(true);

    try {
      const res = await getServices(
        `/api/postrun/report?branch_id=${branch_id || subbranch_id}`,
        access_token
      );
      setLoading(false);
      if (res.responseCode === 200) {
        setPostrunList(res.responseData);
      } else {
        setPostrunList([]);
      }
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`max-w-[1400px] mx-auto px-3 xl:px-0 ${
          decode.role === 2 || decode.role === 1
            ? "py-4 md:py-8"
            : "pb-4 md:pb-8"
        }`}
      >
        {/* <div className="pb-4 md:pb-8 max-w-[1400px] mx-auto"> */}
        {!loading ? (
          <>
            {(decode.role === 2 || decode.role === 1) && (
              <div className="flex gap-2 md:justify-between items-start md:items-center flex-col md:flex-row">
                <div className="flex gap-3 sm:gap-6">
                  <Link
                    to={-1}
                    className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
                  >
                    <p>Emptying Report</p>
                  </Link>
                </div>
              </div>
            )}

            {/* postrun report table */}
            <EmptyingReportTable postrunList={postrunList} />
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[90vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

export default EmptyingReport;
